import { render, staticRenderFns } from "./VendorHead.vue?vue&type=template&id=78e61f98&scoped=true"
import script from "./VendorHead.vue?vue&type=script&lang=js"
export * from "./VendorHead.vue?vue&type=script&lang=js"
import style0 from "./VendorHead.vue?vue&type=style&index=0&id=78e61f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e61f98",
  null
  
)

export default component.exports